import React from 'react';
import { useTickets } from '../../contexts/TicketContext';
import { useAuth } from '../../contexts/AuthContext';
import { useTicketBot } from '../../hooks/useTicketBot';

// Componente individual para gerenciar um único bot de ticket
const TicketBotInstance = ({ ticket }) => {
    const { user } = useAuth();
    const { addTicketResponse, updateTicket, claimBotTask } = useTickets();

    // O hook useTicketBot gerencia todo o ciclo de vida, side-effects e timeouts
    // Ele só age se o ticket estiver em estado válido ('pending' ou 'waiting_input')
    // e se o ticket estiver aguardando sistema.
    useTicketBot(
        ticket,
        user,
        addTicketResponse,
        updateTicket,
        claimBotTask
    );

    return null; // Este componente não renderiza nada visualmente
};

/**
 * Gerenciador Global de Bots
 * Monitora todos os tickets e instancia um bot para aqueles que precisam de verificação.
 * Permite que a verificação ocorra em segundo plano, sem necessidade de abrir o ticket.
 */
const TicketBotManager = () => {
    const { tickets, loading } = useTickets();
    const { user } = useAuth();

    // O bot deve ser executado por qualquer cliente conectado que tenha acesso ao ticket.
    // Como o useTickets já filtra os tickets que o usuário pode ver, 
    // usuários comuns rodarão o bot apenas para seus próprios tickets (o que é ótimo para distribuir carga).
    // const isStaff = user?.accessLevel && user.accessLevel !== 'user';
    // if (!isStaff) return null;

    // Filtra tickets que precisam de atenção do bot
    const ticketsNeedsBot = tickets.filter(t => {
        const status = t.status || t.status;
        const botStateStatus = t.bot_state?.status || t.botState?.status || 'pending';

        // O bot deve rodar para tickets aguardando sistema
        // E deve continuar rodando se o status do bot for pending, starting ou waiting_input
        return status === 'aguardando_sistema' &&
            ['pending', 'starting', 'waiting_input'].includes(botStateStatus);
    });

    if (loading) return null;

    return (
        <>
            {ticketsNeedsBot.map(ticket => (
                <TicketBotInstance key={ticket.id} ticket={ticket} />
            ))}
        </>
    );
};

export default TicketBotManager;
